import React, {useState} from 'react'
import {DisplaySet} from '../model/DisplaySet'
import './DisplaySetsSelection.scss'
import {Checkbox} from '@mui/material'
import {Header} from '../../genericComponents/typographie/UIKitV2/Header'
import LoadingSpinner from '../../genericComponents/LoadingSpinner'
import {Caption} from '../../genericComponents/typographie/UIKitV2/Caption'

export const DisplaySetsSelection = ({
                                         displaySets,
                                         onChange,
                                         headerLabel,
                                         isLoading = false
                                     }: {
    displaySets: DisplaySet[]
    onChange: (pack: DisplaySet[]) => void
    headerLabel: string,
    isLoading?: boolean
}) => {
    const [selectedGroupOfAttributes, setSelectedGroupOfAttributes] = useState<Set<DisplaySet>>(new Set())

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>, pack: DisplaySet) => {
        const {checked} = event.target

        if (checked) {
            selectedGroupOfAttributes.add(pack)
        } else {
            selectedGroupOfAttributes.delete(pack)
        }

        const newSelection = new Set(selectedGroupOfAttributes)
        setSelectedGroupOfAttributes(newSelection)
        onChange([...newSelection])
    }

    const handleSelectAll = () => {
        const newSelection = new Set(displaySets)
        setSelectedGroupOfAttributes(newSelection)
        onChange([...newSelection])
    }

    const handleSelectNone = () => {
        setSelectedGroupOfAttributes(new Set())
        onChange([])
    }

    return (
        <div className="display-set-selection" role="group">
            {displaySets?.length > 0 && (
                <>
                    <Header className="display-set">{headerLabel}</Header>
                    <div className="display-set-selection-list" role="group">
                        <div className="display-set-checkbox-container" role="group">
                            <Checkbox size="small"
                                      data-testid="select-all-display-set"
                                      id="select-all-display-set"
                                      checked={displaySets.every((pack) => selectedGroupOfAttributes.has(pack))}
                                      onChange={
                                          displaySets.every((pack) => selectedGroupOfAttributes.has(pack))
                                              ? handleSelectNone
                                              : handleSelectAll
                                      }
                            />
                            <label htmlFor="select-all-display-set">
                                <Caption>(Select All)</Caption>
                            </label>
                        </div>

                        {isLoading && <LoadingSpinner/>}

                        {displaySets?.length > 0 &&
                            displaySets.map((displaySet) => (
                                <div className="display-set-checkbox-container" role="group">
                                    <Checkbox
                                        id={displaySet.id}
                                        size="small"
                                        checked={selectedGroupOfAttributes.has(displaySet)}
                                        onChange={(event) => handleChange(event, displaySet)}
                                        name={displaySet.label}
                                    />
                                    <label htmlFor={displaySet.id}
                                           data-testid={displaySet.label + '-display-set-selection'}
                                           id={displaySet.id + '-display-set-selection'}>
                                        <Caption>{displaySet.label}</Caption>
                                    </label>
                                </div>
                            ))}
                    </div>
                </>
            )}
        </div>
    )
}